<template>
   <div class="template-wrapper"  :style="getScale">

      <div class="template" id="canvas_template" :style="instanceJson.tmpl.view">

         <!-- Just looping through the zones and displaying them according to the JSON -->
         <component 
            v-if="zones.length > 0"
            v-for="zone in zones"
            v-bind:is="zoneComponent(zone)"
            :zone="zone"
            :currScene="currScene"
            :scale="instanceJson.tmpl.view.scale"
            :isHidden="isHiddenZone(zone)"
            @click.native="handleZoneClicked(zone)"
            @removeAsset="handleRemoveAsset(zone)"
         ></component>
      </div>

      <!-- Scene Buttons -->
      <div class="scene-btns-wrapper" :style="templateWidth" v-if="instanceJson.tmpl.scenes > 1">
         <scene-button v-for="n in sceneCount"
            v-bind:key="n"
            v-bind:id="n"
            :isSelected="isScene(n)"
            @sceneClicked="handleSceneClicked(n)">
         </scene-button>
      </div>

   </div>
</template>

<script>
import AssetZone from './../zones/AssetZone';
import TextZone from './../zones/TextZone';
import ColorZone from './../zones/ColorZone';
import NoEditZone from './../zones/NoEditZone';
import NoEditColorZone from './../zones/NoEditColorZone';
import SceneButton from './../SceneButton';

import {mapState, mapActions} from 'vuex';
export default {

   data() {
      return {
         zones: [],
         scale: 1,
         sceneCount: 0,
      }
   },

   computed: {
      ...mapState([
         'instanceJson',
         'currScene',
         'hiddenZones',
         'locked'
      ]),

      style() {
         return  'width: ' + this.instanceJson.tmpl.view.w + 'px; ' + 'height: ' + this.json.tmpl.view.h + 'px; ';
      },

      templateWidth() {
         return 'width: ' + this.instanceJson.tmpl.view.width;
      },

      getScale() {
         return 'transform: scale(' + this.instanceJson.tmpl.view.scale + ');';
      },

   },

   // props: {
   //    inCanvas: false,
   //    json: {},
   //    hiddenZones: Array,
   //    currScene: String,
   //    moveImage: Number | String
   // },

   created() {
      this.zones = this.instanceJson.tmpl.assets.concat(this.instanceJson.tmpl.data.text);
      this.sceneCount = this.instanceJson.tmpl.scenes;
      this.scale = this.instanceJson.tmpl.view.scale;

      let self = this;
      this.$on('ImageDrag', () => {
         self.$parent.$emit('ImageDrag');
      });
   },

   methods: {
      ...mapActions([
         'changeScene',
         'setActiveZone',
         'removeAsset'
      ]),

      handleSceneClicked(scene) {
         this.changeScene({scene});
      },

      handleZoneClicked(zone) {
         if (!this.locked) {
            this.setActiveZone({zone});
         }
      },

      handleRemoveAsset(zone) {
         this.removeAsset({zone});
      },

      isHiddenZone(zone) {
         return $.inArray(zone.id, this.hiddenZones) > -1;
      },

      /**
         Whether to display the zone or not
       */
      // isActive(asset) {
      //    //if an image zone is in "move state" and this zone is not
      //    //that zone, we're going to hide it
      //    let movingActive = false;
      //    if (this.moveImage == 0 || (this.moveImage > 0 && asset.id == this.moveImage)) {
      //       movingActive = true;
      //    } 

      //    //if the zone is not in the current scene, hide it
      //    let inScene = true;
      //    if (this.instanceJson.tmpl.scenes > 0) {
      //       inScene = $.inArray(this.currScene, asset.scene) > -1;
      //    }
      //    return inScene && movingActive;
      // }, //moved to Zone

      isScene(n) {
         let currScene = parseInt(this.currScene.replace('scene', ""));
         return currScene == n;
      },

      // getZoneTypes(zone) {
      //    if (zone) {
      //       if (zone.type instanceof Array) {
      //          return zone.type;
      //       }
      //       let typeArr = [];
      //       typeArr.push(zone.type);
      //       return typeArr;
      //    }
      // },

      /**
       * Which zone component to load based on zone type
       */
      zoneComponent(zone) {
         if (!zone.replace) {
            if (!zone.type) {
               if (zone.no_edit) {
                  return 'no-edit-zone';
               } else {
                  return 'text-zone';
               }
            } else if (zone.type == 7){
               if (zone.no_edit) {
                  return 'no-edit-color-zone';
               } else {
                  return 'color-zone';
               }
            } else {
               return 'asset-zone';
            }
         }
      },
   },

   watch: {
      instanceJson() {
         this.zones = this.instanceJson.tmpl.assets.concat(this.instanceJson.tmpl.data.text);
      }
   },

   components: {
      AssetZone,
      TextZone,
      ColorZone,
      SceneButton,
      NoEditZone,
      NoEditColorZone,
   }
}
</script>

<style lang="scss" scoped>
   .template-wrapper {
      transform: scale(.35); //default if not set in JSON
      transform-origin: top left;
   }

   .scene-btns-wrapper {
      display: flex;
      position: absolute;
      // max-width: 100%;
      margin-top: 24px;
   }

   .template {
      position: relative;
      // max-width: 100%;
      // max-height: 100%;
      z-index: 1;
   }
</style>
